var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', {
    staticClass: "m-0"
  }, [_c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "12"
    }
  }, _vm._l(_vm.multipleSelected, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "border p-3 card-sr-information-form mb-3"
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "lg": "12 mt-3"
      }
    }, [_c('HeaderDetailItemSR', {
      attrs: {
        "selectedItem": item,
        "optionsTaskType": _vm.optionsTaskType,
        "optionsDepartment": _vm.optionsDepartment,
        "optionsCategory": _vm.optionsCategory,
        "optionsClassification": _vm.optionsClassification,
        "optionsCause": _vm.optionsCause,
        "optionsKindTask": _vm.optionsKindTask,
        "isApprove": true
      }
    })], 1)], 1)], 1);
  }), 0), _c('b-col', {
    staticClass: "my-3 mt-4 d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close Approve")]), !_vm.loading ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save Approve")]) : _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }